var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 4.8 4.8 0 24 0C43.2 0 48 4.8 48 24C48 43.2 43.2 48 24 48C4.8 48 0 43.2 0 24Z",
    fill: "#8282FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2846 9H17.7296C12.2696 9 9.01465 12.255 9.01465 17.715V30.27C9.01465 35.73 12.2696 38.985 17.7296 38.985H30.2846C35.7446 38.985 38.9996 35.73 38.9996 30.27V17.715C38.9996 12.255 35.7446 9 30.2846 9Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2497 18.1355V31.8755C23.2497 32.4155 22.7097 32.7755 22.2147 32.5655C20.3997 31.7855 18.0297 31.0655 16.3797 30.8555L16.0947 30.8255C15.1797 30.7055 14.4297 29.8505 14.4297 28.9205V17.3705C14.4297 16.2305 15.3597 15.3755 16.4997 15.4655C18.3747 15.6155 21.1497 16.5155 22.8897 17.5055C23.1147 17.6105 23.2497 17.8655 23.2497 18.1355Z",
    fill: "#111827"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.57 17.5493V28.9042C33.57 29.8342 32.82 30.6892 31.905 30.8092L31.59 30.8392C29.955 31.0642 27.6 31.7692 25.785 32.5342C25.29 32.7442 24.75 32.3843 24.75 31.8443V18.1192C24.75 17.8492 24.885 17.5943 25.125 17.4593C26.865 16.4843 29.58 15.6142 31.425 15.4492H31.485C32.64 15.4642 33.57 16.3943 33.57 17.5493Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookSquare);
export default __webpack_public_path__ + "static/media/bookSquare.cc2b4332b3af51e0e5968f359eabcd68.svg";
export { ForwardRef as ReactComponent };